import React from 'react';
import { CurrenciesViewRendererProps } from '../types';
import Desktop from './Desktop';

function ViewRenderer(props: CurrenciesViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
